import React from "react";
import { Column, ColumnConfig } from "@ant-design/plots";
import { Props } from "./types";

function ColumnChart(props: Props) {
  const { data, xField, yField, seriesField } = props;

  const config: ColumnConfig = {
    data,
    autoFit: true,
    isGroup: true,
    xField,
    yField,
    seriesField,
    // color: ["#F2994A", "#B93995"],
    // 分组柱状图 组内柱子间的间距 (像素级别)
    dodgePadding: 2,
    // 分组柱状图 组间的间距 (像素级别)
    // intervalPadding: 20,
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
      },
    },
    legend: {
      layout: "horizontal",
      position: "bottom",
    },
    interactions: [
      {
        type: "active-region",
        enable: true,
      },
    ],
  };

  return <Column {...config} />;
}

export default ColumnChart;
